import { render } from "./index.vue?vue&type=template&id=c8e4566a"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=c8e4566a&lang=scss"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__